import { c as _c } from "react/compiler-runtime";
import React, { ReactElement, useState } from 'react';
import ButtonComponent from '@spa/components/button/button/button.component';
import { ButtonType } from '@spa/components/button/types/ButtonType';
import CategoryEntries from './category-entries/category-entries';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import SimpleEntries from './simple-entries/simple-entries';
import classNames from 'clsx';
import styles from './sidebar-navigation.component.module.scss';
import useFullPath from '@spa/lib/react/hooks/useFullPath';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export interface SidebarNavigationEntry {
  readonly label: string;
  readonly path: string | null;
  readonly items: ReadonlyArray<SidebarNavigationEntry>;
}
export interface Props {
  readonly items: ReadonlyArray<SidebarNavigationEntry>;
  readonly simpleVariant: boolean;
  readonly title: string | null;
}
const convertEditorPath = (editorPath: string): string => {
  const editorPathParams = new URLSearchParams(editorPath);
  const path = editorPathParams.get('path');
  return path ? path.replace(/^\/[a-z]{2}\//, '/') : editorPath;
};
const isMainCategoryPagePath = (path: string): boolean => {
  const withoutQuery = path.split('?')[0];
  const withoutLocale = withoutQuery.replace(/^\/[a-z]{2}\//, '/');
  const segments = withoutLocale.split('/').filter(segment => segment.length > 0);
  const categoryIndex = segments.indexOf('c');
  return categoryIndex !== -1 && segments.length - categoryIndex === 2;
};
const SidebarNavigationComponent = t0 => {
  const $ = _c(17);
  const {
    items,
    simpleVariant,
    title
  } = t0;
  const {
    fullPath,
    pathname
  } = useFullPath();
  let t1;
  if ($[0] !== fullPath || $[1] !== pathname) {
    t1 = pathname.startsWith("/cms-editor/") ? convertEditorPath(fullPath) : fullPath;
    $[0] = fullPath;
    $[1] = pathname;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const currentPath = t1;
  let t2;
  if ($[3] !== currentPath) {
    t2 = isMainCategoryPagePath(currentPath);
    $[3] = currentPath;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const isMainCategoryPage = t2;
  const [isOpen, setIsOpen] = useState(false);
  const {
    formatMessage
  } = useNamespacedIntl("sidebar");
  let t3;
  if ($[5] !== title) {
    t3 = title?.trim() && <h1 className={classNames("h2", styles["sidebar-navigation__headline"])}>{title}</h1>;
    $[5] = title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== currentPath || $[8] !== formatMessage || $[9] !== isMainCategoryPage || $[10] !== isOpen || $[11] !== items || $[12] !== simpleVariant) {
    t4 = items.length > 0 && <nav className={styles["sidebar-navigation__nav"]}><div className={styles["sidebar-navigation__toggle"]}><ButtonComponent buttonType={ButtonType.AS_TEXT} text={formatMessage(isOpen ? "closeNavigation" : "openNavigation")} onClick={() => setIsOpen(!isOpen)} /></div><div className={classNames(styles["sidebar-navigation__content"], {
        [styles["sidebar-navigation__content--open"]]: isOpen
      })}>{simpleVariant ? <SimpleEntries entries={items} currentPath={currentPath} /> : <CategoryEntries entries={items} isMainCategoryPage={isMainCategoryPage} />}</div></nav>;
    $[7] = currentPath;
    $[8] = formatMessage;
    $[9] = isMainCategoryPage;
    $[10] = isOpen;
    $[11] = items;
    $[12] = simpleVariant;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t3 || $[15] !== t4) {
    t5 = <div className={styles["sidebar-navigation"]}>{t3}{t4}</div>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
export default SidebarNavigationComponent;